import React from 'react';

interface SkeletonProps {
  height?: string;
  width?: string;
  borderRadius?: string;
  marginBottom?: string;
  className?: string;
}

/**
 * Skeleton loading component that shows a placeholder while content is loading
 */
const Skeleton: React.FC<SkeletonProps> = ({
  height = '16px',
  width = '100%',
  borderRadius = '4px',
  marginBottom = '0',
  className = '',
}) => {
  const styles = {
    height,
    width,
    borderRadius,
    marginBottom,
    backgroundColor: '#eee',
    backgroundImage: 'linear-gradient(90deg, #eee 0%, #f5f5f5 50%, #eee 100%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
    display: 'block',
  } as React.CSSProperties;

  return (
    <div
      className={`skeleton ${className}`}
      style={styles}
      data-testid="skeleton-loader"
    />
  );
};

export default Skeleton;